/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

const apiVersion = '/v1';
const endPoint = '/request-xml-json';

export default class WMS {
  static async getCapabilities(url) {
    let uri = `${url}?service=WMS&version=1.1.0&request=GetCapabilities`;
    return axios(`${process.env.REACT_APP_API_HOST}${apiVersion}${endPoint}`, {
      params: {
        uri,
      },
    });
  }
}
